// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__3qGeN","logo":"footer_logo__potiX","link":"footer_link__3C-jS","copyright":"footer_copyright__1U9Ia"};